import { render, staticRenderFns } from "./ReportedCase.vue?vue&type=template&id=217f9ba6&scoped=true"
import script from "./ReportedCase.vue?vue&type=script&lang=js"
export * from "./ReportedCase.vue?vue&type=script&lang=js"
import style0 from "./ReportedCase.vue?vue&type=style&index=0&id=217f9ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217f9ba6",
  null
  
)

export default component.exports